import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { facetInfoNeededState } from 'components/search/facets.state';

/**
 * This hook uses an effect to set the 'facetInfoNeeded' flag.
 */
export const useFacetsNeeded = () => {
  const setFacetInfoNeeded = useSetRecoilState(facetInfoNeededState);
  useEffect(() => {
    setFacetInfoNeeded(true);
  }, []);
};
